import React from 'react';

const Service = () => {
    return (
        <div className="container">
         <h4 className="center">Service</h4>
         
         <p> this my about page people</p>
        </div>
    )
}

export default Service



















